import React from 'react';
import './Testimonials.css';
import { FiStar } from 'react-icons/fi';

const testimonials = [
  {
    quote:
      'They built the appointment system end-to-end and stayed available after launch. The patient flow is genuinely simpler than what we had before.',
    author: 'Dr. Aravind R.',
    role: 'Clinic Operations · Chennai',
    initials: 'AR',
  },
  {
    quote:
      'Honest scope, honest timeline. We saw a working build in week two and shipped to production in six. That alone was worth the engagement.',
    author: 'Karthik S.',
    role: 'Founder · D2C Startup',
    initials: 'KS',
  },
  {
    quote:
      'What I liked most: no jargon. They explained trade-offs in plain language and let us make informed calls. Felt like an in-house team.',
    author: 'Priya M.',
    role: 'Product Lead · EdTech',
    initials: 'PM',
  },
];

const Testimonials = () => {
  return (
    <section className="testimonials section">
      <div className="container">
        <div className="section-header">
          <span className="section-eyebrow">Trust</span>
          <h2 className="section-title section-title--center">
            What people say about working with us.
          </h2>
        </div>

        <div className="testimonials-grid">
          {testimonials.map((t) => (
            <figure key={t.author} className="testimonial card">
              <div className="testimonial-stars">
                {[...Array(5)].map((_, i) => <FiStar key={i} />)}
              </div>
              <blockquote className="testimonial-quote">
                "{t.quote}"
              </blockquote>
              <figcaption className="testimonial-author">
                <span className="testimonial-avatar">{t.initials}</span>
                <div>
                  <strong>{t.author}</strong>
                  <span>{t.role}</span>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>

        <div className="trust-row">
          <div className="trust-item">
            <strong>Source code, always yours.</strong>
            <span>You own every line of code we write. Full handover, day one.</span>
          </div>
          <div className="trust-item">
            <strong>NDA-friendly.</strong>
            <span>Happy to sign mutual NDAs before discussing anything sensitive.</span>
          </div>
          <div className="trust-item">
            <strong>Fixed-price options.</strong>
            <span>We can offer fixed-scope quotes once requirements are clear.</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
